import { StringToPrimitive } from '../utils'

// TODO: Add Flow annotations and unit tests
let Modules = []
const MODULE_DATA_ATTR = 'data-js-modules'
const SELECTOR = `[${MODULE_DATA_ATTR}]`

/*
    Example expected markup:

    note: Module names need to match the corresponding js filename and classname
    note: All module options are namespaced for differentiation

    <div data-js-modules="moduleName1, moduleName2"
         data-moduleName1-config-option="value"
         data-moduleName1-another-config-option="value"
         data-moduleName2-config-option="value"
         data-moduleName2-another-config-option="value">
        ...
    </div>

    note: the data property names are coersed to CamelCase
    eg: data-moduleName1-config-option="123" => {moduleName1ConfigOption: 123}
*/


// Collect and prepare config options from data attributes
// Returns javascript object
const propsToConfig = (props, moduleName) => {
  const sanitisedObj = {}

  for (let prop in props) {
    const regex = RegExp(`${moduleName}([A-Z])`, 'ig')
    // Remove the module name and make the first letter of the propname lowercase (camelCasing)
    const sanitisedProp = prop.replace(regex, function() {
      return arguments[1].toLowerCase()
    }) // eslint-disable-line no-undef

    prop = StringToPrimitive.convert(prop)
    sanitisedObj[sanitisedProp] = props[prop]
  }

  return sanitisedObj
};

const initElementModules = ($el, requiredModules = '') => {
  // convert comma separated module names to array
  requiredModules = requiredModules.split(',')

  // initialise every module factory required by this element
  requiredModules.forEach(moduleName => {
    // Extract module from our modules folder (case insensitive search)
    let module = ''

    // Strip dashes to allow legible data attribute representation in the view
    moduleName = moduleName.replace(/\-/g, '')

    for (const name in Modules) {
      const regex = RegExp(name, 'i')

      if (regex.test(moduleName)) {
        module = Modules[name]
        break
      }
    }

    if (!module) return

    // Generate js config object from matched data attributes on a given element
    const config = propsToConfig($el.dataset, moduleName) || {}

    // Assumes all modules are classes
    // TODO: Consider supporting plain factories / modules
    const mod = new module($el, config)

    // All Modules require an 'init' function to run
    // Typescript? lol
    mod.init()
  })
}

const init = (modules = []) => {
  Modules = modules;

  [...document.querySelectorAll(SELECTOR)].forEach($el =>
    initElementModules($el, $el.getAttribute('data-js-modules'))
  )
}

export default init



// WEBPACK FOOTER //
// ./js/modules/ModulesInitializer.js